export default "__VITE_ASSET__CV9KliOp__"